import React, { Component } from 'react';
import { AfspReact } from '@bit/ui-common.ui-components/afsp';
import tsaLogo from '@bit/ui-common.ui-components/afsp/images/dhs-logo-01.png';
import userIcon from '@bit/ui-common.ui-components/afsp/images/user-icon-01.png';
import { Row, Col, Steps, Button, Icon } from 'antd';
import EmailChangeNotice from 'components/login/EmailChangeNotice';
import EmailIdentificationAndChange from 'components/login/EmailIdentificationAndChange';
import EmailPassportDetails from 'components/login/EmailPassportDetails';
import EmailSecurityQuestions from 'components/login/EmailSecurityQuestions';
import EmailChangeVerification from 'components/login/EmailChangeVerification';
import EmailUpdateIndicator from 'components/login/EmailUpdateIndicator';

const
{ Step } = Steps,
layout = {
    size: {
        header: 'xs',
        footer: 'xs'
    },
    images: {
        logo: tsaLogo,
        user: userIcon
    },
    controlType: 'home',
    bgc: '#e6e6e6'
};

export default class ChangeEmail extends Component {
    state = {
        currentStep: 0,
        steps: [
            { title: 'Notice', icon: 'home', content: props => <EmailChangeNotice {...props} /> },
            { title: 'Change', icon: 'form', content: props => <EmailIdentificationAndChange {...props} /> },
            { title: 'Passport', icon: 'user', content: props => <EmailPassportDetails {...props} /> },
            { title: 'Security', icon: 'lock', content: props => <EmailSecurityQuestions {...props} /> },
            { title: 'Verification', icon: 'exception', content: props => <EmailChangeVerification {...props} /> }
        ]
    }

    constructor(props) { super(props); }

    changeStep = type => {
        let { currentStep } = this.state;

        let offset = 0;
        if(type.indexOf(':') === -1) offset =  1;
        else offset = parseInt(type.substring(type.indexOf(':') + 1, type.length));

        switch(type) {
            case 'back':
                this.setState({...this.state, currentStep: currentStep - offset });
                break;
            case 'next':
                this.setState({...this.state, currentStep: currentStep + offset });
                break;
            default: this.setState({...this.state, currentStep: offset });
        }
    }

    clickStep = step => {
        const { steps } = this.state;
        for(let s in steps)
            if(steps[s].title === step) {
                this.changeStep(`:${s}`);
                break;
            }
    }

    render() {
        const
        { steps, currentStep } = this.state,
        { state, services } = this.props,
        { emailUpdateRequest, showPasswordResetModal } = state.passwordReset;
        return (
            <div>
                <AfspReact.Layout {...layout}>
                    <div style={{ margin: '20px 20%' }}>
                        <div style={{
                            padding: '10px 25px',
                            backgroundColor: 'rgb(255, 255, 255)',
                            borderRadius: '40px',
                            borderStyle: 'solid',
                            borderWidth: '1px',
                            borderColor: 'rgb(210, 210, 210)'
                        }}>
                            <Steps current={currentStep}>
                                {steps.map(i => (<Step
                                    key={i.title}
                                    icon={i.icon}
                                    title={(
                                        <div
                                            name={i.title}
                                            style={{ display: 'inline-block', cursor: 'pointer' }}
                                            onClick={e => this.clickStep(e.target.getAttribute('name'))}
                                        >
                                            {i.title}
                                        </div>
                                    )}
                                />))}
                            </Steps>
                        </div>
                    </div>
                    {currentStep === 0 ? null : (
                        <div style={{ position: 'absolute', top: '57%', transform:' translateY(-50%)', left: '20%' }}>
                            <Button
                                style={{ width: '100px', borderRadius: '20px 4px 4px 20px' }}
                                onClick={() => this.changeStep('back')}
                                disabled={emailUpdateRequest.status != null ? true : false}
                            >
                                <Icon type='left' />
                                {'Back'}
                            </Button>
                        </div>
                    )}
                    <div style={{
                        position: 'absolute',
                        transform: 'translate(-50%, -50%)',
                        top: '57%',
                        left: '50%'
                    }}>
                        <div className='steps-content'>
                            {steps[currentStep].content(this.props)}
                        </div>
                    </div>
                    {currentStep === (steps.length - 1) ? null : (
                        <div style={{ position: 'absolute', top: '57%', transform:' translateY(-50%)', right: '20%' }}>
                            <Button
                                style={{ width: '100px', borderRadius: '4px 20px 20px 4px' }}
                                onClick={() => this.changeStep('next')}
                                disabled={emailUpdateRequest.status != null ? true : false}
                            >
                                {'Next'}
                                <Icon type='right' />
                            </Button>
                        </div>
                    )}
                    <EmailUpdateIndicator
                        doClose={() => {
                            services.resetCaptchaValidation();
                            services.loadCaptcha();
                            services.resetEmailUpdateRequest();
                            this.clickStep('Change');
                        }}
                        clearFields={() => {
                            let inputFields = [
                                'emailId',
                                'emailAddress1',
                                'emailAddress2',
                                'passportNumber',
                                'passportCountry',
                                'securityQuestion1',
                                'securityQuestion2',
                                'securityQuestion3'
                            ];

                            for(let i in inputFields)
                                services.updateResetField(inputFields[i], '');
                        }}
                        services={services}
                        request={emailUpdateRequest}
                        show={showPasswordResetModal}
                    />
                </AfspReact.Layout>
            </div>
        );
    }
}
